import { Routes } from '@angular/router';
import { TableComponent } from '../../shared/component/table/table.component';
import { SiteComponent } from '../DashboardScreens/site/site.component';
import { RechargeReportComponent } from '../DashboardScreens/Reports/recharge-report/recharge-report.component';
import { MonthlyReportComponent } from '../DashboardScreens/Reports/monthly-report/monthly-report.component';
import { DailyReportComponent } from '../DashboardScreens/Reports/daily-report/daily-report.component';
import { DrCrReportComponent } from '../DashboardScreens/Reports/dr-cr-report/dr-cr-report.component';
import { BillingReportComponent } from '../DashboardScreens/Reports/billing-report/billing-report.component';
import { LoadtypeMasterComponent } from '../DashboardScreens/Reports/loadtype-master/loadtype-master.component';
import { AssetsMasterComponent } from '../DashboardScreens/Reports/assets-master/assets-master.component';
import { ReadingCalibrationComponent } from '../DashboardScreens/Reports/reading-calibration/reading-calibration.component';
import { GatewayTabularComponent } from '../DashboardScreens/gateway-tabular/gateway-tabular.component';
import { AddSitesComponent } from '../DashboardScreens/add-sites/add-sites.component';
import { ApplicationComponent } from '../DashboardScreens/assets/application/application.component';
import { EditSiteComponent } from '../DashboardScreens/edit-site/edit-site.component';
import { BulkActionComponent } from '../DashboardScreens/bulk-action/bulk-action.component';
import { BulkActionCreateComponent } from '../DashboardScreens/bulk-action-create/bulk-action-create.component';
import { ConfigurationComponent } from '../DashboardScreens/configuration/configuration.component';
import { AlarmsComponent } from '../DashboardScreens/log/log-table/alarms/alarms.component';
import { MeterChangeLogsComponent } from '../DashboardScreens/log/log-table/meter-change-logs/meter-change-logs.component';
import { DGRunningLogsComponent } from '../DashboardScreens/log/log-table/dgrunning-logs/dgrunning-logs.component';
import { GatewayActionLogsComponent } from '../DashboardScreens/log/log-table/gateway-action-logs/gateway-action-logs.component';
import { LoadSurveyComponent } from '../DashboardScreens/log/log-table/load-survey/load-survey.component';
import { SMSLogsComponent } from '../DashboardScreens/log/log-table/smslogs/smslogs.component';
import { MemberDetailsComponent } from '../DashboardScreens/Reports/member-details/member-details.component';
import { ZeroReadingComponent } from '../DashboardScreens/Reports/zero-reading/zero-reading.component';
import { UnHealthyMeterComponent } from '../DashboardScreens/Reports/un-healthy-meter/un-healthy-meter.component';
import { CurrentvsProcessedReadingComponent } from '../DashboardScreens/Reports/currentvs-processed-reading/currentvs-processed-reading.component';
import { MeterConfigurationComponent } from '../DashboardScreens/Reports/meter-configuration/meter-configuration.component';
import { CutMeterListComponent } from '../DashboardScreens/Reports/cut-meter-list/cut-meter-list.component';
import { EngineerListComponent } from '../DashboardScreens/Reports/engineer-list/engineer-list.component';
import { HourlyConsumptionComponent } from '../DashboardScreens/Reports/hourly-consumption/hourly-consumption.component';
import { ZeroConsumptionReportComponent } from '../DashboardScreens/Reports/zero-consumption-report/zero-consumption-report.component';
import { CurrentDataComponent } from '../DashboardScreens/Reports/current-data/current-data.component';
import { ProcessDataComponent } from '../DashboardScreens/Reports/process-data/process-data.component';
import { ConsumerListComponent } from '../DashboardScreens/consumer-list/consumer-list.component';
import { CutoffmeterListComponent } from '../DashboardScreens/cutoffmeter-list/cutoffmeter-list.component';
import { RechargeComponent } from '../DashboardScreens/recharge/recharge.component';
import { RechargeCouponComponent } from '../DashboardScreens/recharge/coupon/recharge-coupon.component';
import { CouponRechargeComponent } from '../DashboardScreens/recharge/coupon-recharge/coupon-recharge.component';
import { MonthlyBillingReportComponent } from '../DashboardScreens/Reports/monthly-billing-report/monthly-report.component';
import { SiteloginComponent } from '../DashboardScreens/Reports/sitelogin/sitelogin.component';
import { RechargeLogsComponent } from '../DashboardScreens/log/log-table/recharge-logs/recharge-logs.component';
import { DgRunningReportsComponent } from '../DashboardScreens/Reports/dg-running-reports/dg-running-reports.component';
import { EvSummaryComponent } from '../DashboardScreens/ev-summary/ev-summary.component';
import { EvChargerComponent } from '../DashboardScreens/ev-charger/ev-charger.component';
import { GrRestoreComponent } from '../DashboardScreens/groupactions/gr-restore/gr-restore.component';
import { AlarmsDashboardComponent } from '../DashboardScreens/alarm-summary-dashboard/alarm-dashboard.component';
import { GrCutComponent } from '../DashboardScreens/groupactions/gr-cut/gr-cut.component';
// import { RbackPerms } from '../DashboardScreens/rback/rback-perms/rback-perms.component';
// import { RbacViewComponent } from '../DashboardScreens/rback/rbackform/rbackform.component';
// import { RbacConfigComponent } from '../DashboardScreens/rback/rbac-config.component';
import { AnalytictablesComponent } from '../DashboardScreens/analytic-div/analytictables/analytictables.component';
import { RbacShellComponent } from '../DashboardScreens/components/rbac-shell.component';
import { PermissionManagementComponent } from '../DashboardScreens/components/permission-management/permission-management.component';
import { CSVREPORTComponent } from '../DashboardScreens/Reports/csv-report/csv-report.component';
import { ComponentBuilder } from '../../shared/component/form-modal/component-builder/component-builder';
import { UnifiedReportComponent } from '../DashboardScreens/Reports/unified-report/unified-report.component';
import { UnifiedLogComponent } from '../DashboardScreens/log/unified-log/unified-log.component';
export const pages: Routes = [
  {
    path: '',
    redirectTo: 'site_summary',
    pathMatch: 'full',
  },
  // { path: 'rbackperms',
  //   component: RbackPerms
  // },
  // { path: 'rbackperms',
  //   component: RbacConfigComponent
  // },



  {
    path: 'administrator',
    component: RbacShellComponent
  },
  {
    path: 'permission/:loginType',
    component: PermissionManagementComponent,
    data: {
      parentBreadcrumb: 'Permissions',
      childBreadcrumb: 'Permissions'
    }
  },
  {
    path: 'coupon_recharge',
    data: {
      parentBreadcrumb: 'Coupon Recharge',
      childBreadcrumb: 'Coupon Recharge'
    },
    children: [
      {
        path: '',
        redirectTo: 'generate_coupon',
        pathMatch: 'full'
      },
      {
        path: 'generate_coupon',
        component: RechargeCouponComponent,
        data: {
          parentBreadcrumb: 'Coupon Recharge',
          childBreadcrumb: 'Generate Coupon'
        }
      },
      {
        path: 'recharge',
        component: CouponRechargeComponent,
        data: {
          parentBreadcrumb: 'Coupon Recharge',
          childBreadcrumb: 'Recharge'
        }
      },
      {
        path: 'coupon_discard',
        redirectTo: 'recharge',
        pathMatch: 'full'
      },
    ]
  },

  {
    path: 'recharge',
    component: RechargeComponent,
    data: {
      parentBreadcrumb: 'Recharge',
      childBreadcrumb: 'Recharge'
    }
  },
  {
    path: 'bulk_reports',
    data: {
      parentBreadcrumb: 'Bulk Report',
      childBreadcrumb: 'Bulk Report',
    },
    children: [
      {
        path: 'recharge_history',
        component: CSVREPORTComponent,
        data: {
          parentBreadcrumb: 'Recharge History',
          childBreadcrumb: 'Recharge History',
          reportType: 'RECHARGE_HISTORY_CSV',
        },
      },
      {
        path: 'daily_data',
        component: CSVREPORTComponent,
        data: {
          parentBreadcrumb: 'Daily Data',
          childBreadcrumb: 'Daily Data',
          reportType: 'DAILY_REPORT_CSV',
        },
      },
      {
        path: 'monthly_data',
        component: CSVREPORTComponent,
        data: {
          parentBreadcrumb: 'Monthly Data',
          childBreadcrumb: 'Monthly Data',
          reportType: 'MONTHLY_REPORT_CSV',
        },
      },
    ],
  },
  {
    path: 'comp_build',
    component: ComponentBuilder
  },
  {
    path: 'ev_summary',
    component: EvSummaryComponent,
    data: {
      parentBreadcrumb: 'EV Summary',
      childBreadcrumb: 'EV Summary',
    },
  },
  {
    path: 'ev_charger',
    component: EvChargerComponent,
    data: {
      parentBreadcrumb: 'EV Summary',
      childBreadcrumb: 'EV Charger Detail',
    },
  },
  {
    path: 'alarm_summary',
    component: AlarmsDashboardComponent,
    data: {
      parentBreadcrumb: 'Alarm Summary',
      childBreadcrumb: 'Alarm Summary',
    },
  },
  {
    path: 'reports',
    children: [
      {
        path: '',
        redirectTo: 'recharge_report',
        pathMatch: 'full'
      },
      {
        path: 'recharge_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Recharge Report',
          childBreadcrumb: 'Recharge Report',
        },
      },
      {
        path: 'detailed_dg_running_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Detailed DG Running Report',
          childBreadcrumb: 'Detailed DG Running Report',
        },
      },
      {
        path: 'monthly_bill',
        pathMatch: 'full',
        component: MonthlyBillingReportComponent,
        data: {
          parentBreadcrumb: 'Monthly Statement',
          childBreadcrumb: 'Monthly Statement',
        },
      },
      {
        path: 'billing_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Billing Report',
          childBreadcrumb: 'Billing Report',
        },
      },
      {
        path: 'monthly_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Monthly Report',
          childBreadcrumb: 'Monthly Report',
        },
      },
      {
        path: 'daily_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Daily Report',
          childBreadcrumb: 'Daily Report',
        },
      },
      {
        path: 'debit-credit_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Debit-Credit Report',
          childBreadcrumb: 'Debit-Credit Report',
        },
      },
      {
        path: 'load_type_master',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Load Type Master',
          childBreadcrumb: 'Load Type Master',
        },
      },
      {
        path: 'site_user_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Site User Report',
          childBreadcrumb: 'Site User Report',
        },
      },
      {
        path: 'sitelogin-report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Site User Report',
          childBreadcrumb: 'Site User Report',
        },
      },
      {
        path: 'site-user-report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Site User Report',
          childBreadcrumb: 'Site User Report',
        },
      },
      {
        path: 'assets_master',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Assets Master',
          childBreadcrumb: 'Assets Master',
        },
      },
      {
        path: 'reading_calibration',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Reading Calibration',
          childBreadcrumb: 'Reading Calibration',
        },
      },
      {
        path: 'member_details',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Member Details',
          childBreadcrumb: 'Member Details',
        },
      },
      {
        path: 'zero_reading',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Zero Reading',
          childBreadcrumb: 'Zero Reading',
        },
      },
      {
        path: 'unhealthy_meter',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Unhealthy Meter',
          childBreadcrumb: 'Unhealthy Meter',
        },
      },
      {
        path: 'current_vs_processed_reading_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Current vs Processed Reading Report',
          childBreadcrumb: 'Current vs Processed Reading Report',
        },
      },
      {
        path: 'meter_configuration_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Meter Configuration Report',
          childBreadcrumb: 'Meter Configuration Report',
        },
      },
      {
        path: 'cut_meter_list_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Cut Meter List Report',
          childBreadcrumb: 'Cut Meter List Report',
        },
      },
      {
        path: 'engineer_list',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Engineer List',
          childBreadcrumb: 'Engineer List',
        },
      },
      {
        path: 'hourly_consumption_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Hourly Consumption Report',
          childBreadcrumb: 'Hourly Consumption Report',
        },
      },
      {
        path: 'process_data',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Process Data',
          childBreadcrumb: 'Process Data',
        },
      },
      {
        path: 'current_data',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Current Data',
          childBreadcrumb: 'Current Data',
        },
      },
      {
        path: 'zero_consumption_report',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Zero Consumption Report',
          childBreadcrumb: 'Zero Consumption Report',
        },
      },
      {
        path: 'monthly_max_demand',
        pathMatch: 'full',
        component: UnifiedReportComponent,
        data: {
          parentBreadcrumb: 'Monthly Max Demand Report',
          childBreadcrumb: 'Monthly Max Demand Report',
        },
      }
    ]
  },
  {
    path: 'logs',
    children: [
      {
        path: '',
        redirectTo: 'dg_running',
        pathMatch: 'full'
      },
      {
        path: 'alarms',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'Alarms Logs',
          childBreadcrumb: 'Alarms Logs',
        },
      },
      {
        path: 'loadtype_change',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'Load Type Change Logs',
          childBreadcrumb: 'Load Type Change Logs',
        },
      },
      {
        path: 'recharge_logs',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'Recharge Logs',
          childBreadcrumb: 'Recharge Logs',
        },
      },
      {
        path: 'meter_change',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'Meter Change Logs',
          childBreadcrumb: 'Meter Change Logs',
        },
      },
      {
        path: 'dg_running',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'DG Running Logs',
          childBreadcrumb: 'DG Running Logs',
        },
      },
      {
        path: 'device_actions',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'Device Actions',
          childBreadcrumb: 'Device Actions',
        },
      },
      {
        path: 'load_survey',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'Load Survey',
          childBreadcrumb: 'Load Survey',
        },
      },
      {
        path: 'sms-email',
        pathMatch: 'full',
        component: UnifiedLogComponent,
        data: {
          parentBreadcrumb: 'SMS Logs',
          childBreadcrumb: 'SMS Logs',
        },
      },
    ]
  },
  {
    path: 'dashboard',
    children: [
      {
        path: '',
        redirectTo: 'site_summary',
        pathMatch: 'full'
      },
      {
        path: 'site_summary',
        loadComponent: () =>
          import('../DashboardScreens/site-summary/site-summary.component').then(m => m.SiteSummaryComponent),
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Site Summary',
        },
        children: [
          {
            path: '',
            loadComponent: () =>
              import('../DashboardScreens/analytic-div/analytic-div.component').then(m => m.AnalyticDivComponent),
            data: {
              childBreadcrumb: '',
            },
          },
          {
            path: 'site',
            component: SiteComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total Site',
            },
          },
          {
            path: 'consumer',
            component: ConsumerListComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total Consumer',
            },
          },
          {
            path: 'cut_meter',
            component: CutoffmeterListComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Cut Meter "No"',
            },
          },
          {
            path: 'detailed_meter',
            component: CutoffmeterListComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Meter',
            },
          },
          {
            path: 'ticket_generated',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total Tickets Generated',
            },
          },
          {
            path: 'gateway',
            component: GatewayTabularComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total Gateway',
            },
          },
          {
            path: 'cb',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total CB',
            },
          },
          {
            path: 'disconnected_meter',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total Disconnected Meter',
            },
          },
          {
            path: 'dg_meter',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total Diesel Generator',
            },
          },
          {
            path: 'meter',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total Meter',
            },
          },
          {
            path: 'woq',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Total W.O.Q',
            },
          },
          {
            path: 'DG',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'DG ON',
            },
          },
          {
            path: 'GRID',
            component: TableComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'GRID ON',
            },
          },
          {
            path: 'zeroReading',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Zero Reading',
            },
          },
          {
            path: 'sensorCutOff',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Meter Cut off',
            },
          },
          {
            path: 'cbNotConnected',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Cb Not Conencted',
            },
          },
          {
            path: 'dlNotConnected',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Gateway Not Connected',
            },
          },
          {
            path: 'ConsumptionWORecharge',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Consumption Without Recharge',
            },
          },
          {
            path: 'GridOverload',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Grid Overload',
            },
          },
          {
            path: 'DGOverload',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'DG Overload',
            },
          },
          {
            path: 'lowbalance',
            component: AnalytictablesComponent,
            data: {
              parentBreadcrumb: 'Site Summary',
              childBreadcrumb: 'Low Balance',
            },
          }
        ]
      },
      {
        path: 'ev_summary',
        component: EvSummaryComponent,
        data: {
          parentBreadcrumb: 'EV Summary',
          childBreadcrumb: 'EV Summary',
        },
      },
      {
        path: 'ev_charger',
        component: EvChargerComponent,
        data: {
          parentBreadcrumb: 'EV Summary',
          childBreadcrumb: 'EV Charger Detail',
        },
      },
      {
        path: 'alarm_summary',
        component: AlarmsDashboardComponent,
        data: {
          parentBreadcrumb: 'Alarm Summary',
          childBreadcrumb: 'Alarm Summary',
        },
      },
      {
        path: 'recharge_summary',
        loadComponent: () =>
          import('../DashboardScreens/recharge-summary/recharge-summary.component').then(m => m.RechargeSummaryComponent),
        data: {
          parentBreadcrumb: 'Recharge Summary',
          childBreadcrumb: 'Recharge Summary',
        },
      },
      {
        path: 'consumer_details',
        loadComponent: () =>
          import('../DashboardScreens/consumer-detail/consumer-detail.component').then(m => m.ConsumerDetailComponent),
        data: {
          parentBreadcrumb: 'Consumer Details',
          childBreadcrumb: 'Consumer Details',
        },
      }
    ]
  },
  {
    path: 'site_summary',
    loadComponent: () =>
      import('../DashboardScreens/site-summary/site-summary.component').then(m => m.SiteSummaryComponent),
    data: {
      parentBreadcrumb: 'Site Summary',
      childBreadcrumb: 'Site Summary',
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../DashboardScreens/analytic-div/analytic-div.component').then(m => m.AnalyticDivComponent),
        data: {
          childBreadcrumb: '',
        },
      },
      {
        path: 'site',
        component: SiteComponent,
        data: {
          parentBreadcrumb: 'Site Summary', // <-- Parent breadcrumb from site_summary
          childBreadcrumb: 'Total Site',
        },
      },
      {
        path: 'consumer',
        component: ConsumerListComponent,
        data: {
          parentBreadcrumb: 'Site Summary', // <-- Parent breadcrumb from site_summary
          childBreadcrumb: 'Total Consumer',
        },
      },
      {
        path: 'cut_meter',
        component: CutoffmeterListComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Cut Meter "No"',
        },
      },
      {
        path: 'detailed_meter',
        component: CutoffmeterListComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: ' "No"',
        },
      },
      {
        path: 'ticket_generated',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Total Tickets Generated',
        },
      },
      {
        path: 'gateway',
        component: GatewayTabularComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Total Gateway',
        },
      },
      {
        path: 'cb',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Total CB',
        },
      },
      {
        path: 'disconnected_meter',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Total Disconnected Meter',
        },
      },
      {
        path: 'dg_meter',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Total Diesel Generator',
        },
      },
      {
        path: 'meter',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Total Meter',
        },
      },
      {
        path: 'woq',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Total W.O.Q',
        },
      },
      {
        path: 'DG',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'DG ON',
        },
      },
      {
        path: 'GRID',
        component: TableComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'GRID ON',
        },
      },
      {
        path: 'zeroReading',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Zero Reading',
        },
      },
      {
        path: 'sensorCutOff',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Meter Cut off',
        },
      },
      {
        path: 'cbNotConnected',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Cb Not Conencted',
        },
      },
      {
        path: 'dlNotConnected',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Gateway Not Connected',
        },
      },
      {
        path: 'ConsumptionWORecharge',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Consumption Without Recharge',
        },
      },
      {
        path: 'GridOverload',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Grid Overload',
        },
      },
      {
        path: 'DGOverload',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'DG Overload',
        },
      },
      {
        path: 'lowbalance',
        component: AnalytictablesComponent,
        data: {
          parentBreadcrumb: 'Site Summary',
          childBreadcrumb: 'Low Balance',
        },
      }
    ],

  },
  {
    path: 'consumer_search',
    loadComponent: () =>
      import('../DashboardScreens/consumer-dashboard/consumer-dashboard.component').then(m => m.ConsumerDashboardComponent),
    data: {
      parentBreadcrumb: 'Consumer Search',
      childBreadcrumb: 'Consumer Search',
    },
  },
  {
    path: 'ConsumerDetail',
    loadComponent: () =>
      import('../DashboardScreens/consumer-detail/consumer-detail.component').then(m => m.ConsumerDetailComponent),
    data: {
      parentBreadcrumb: 'Consumer Detail',
      childBreadcrumb: 'Consumer Detail',
    },
  },
  {
    path: 'recharge_summary',
    loadComponent: () =>
      import('../DashboardScreens/recharge-summary/recharge-summary.component').then(m => m.RechargeSummaryComponent),
    data: {
      parentBreadcrumb: 'Recharge Summary',
      childBreadcrumb: 'Recharge Summary',
    },
  },
  /*  */
  {
    path: 'assets',
    children: [
      {
        path: '',
        redirectTo: 'application',
        pathMatch: 'full'
      },
      {
        path: 'application',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Application',
          childBreadcrumb: 'Assets/Application',
        },
      },
      {
        path: 'processor',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/processor',
          childBreadcrumb: 'Assets/processor',
        },
      },
      {
        path: 'site_solution_type',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Site Solution Type',
          childBreadcrumb: 'Assets/Site Solution Type',
        },
      },
      {
        path: 'communications',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Communications',
          childBreadcrumb: 'Assets/Communications',
        },
      },
      {
        path: 'customer',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Customer',
          childBreadcrumb: 'Assets/Customer',
        },
      },
      {
        path: 'payment_gateway',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Payment Gateway',
          childBreadcrumb: 'Assets/Payment Gateway',
        },
      },
      {
        path: 'engineer',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Payment Gateway',
          childBreadcrumb: 'Assets/Payment Gateway',
        },
      },
      {
        path: 'site_sms_service',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Payment Gateway',
          childBreadcrumb: 'Assets/Payment Gateway',
        },
      },
      {
        path: 'meter_make',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Payment Gateway',
          childBreadcrumb: 'Assets/Payment Gateway',
        },
      },
      {
        path: 'bulk_command',
        pathMatch: 'full',
        component: ApplicationComponent,
        data: {
          parentBreadcrumb: 'Assets/Payment Gateway',
          childBreadcrumb: 'Assets/Payment Gateway',
        },
      },
    ]
  },
  /*  */
  {
    path: 'log_viewer',
    loadComponent: () =>
      import('../DashboardScreens/log/u-i/u-i.component').then(m => m.UIComponent),
    data: {
      parentBreadcrumb: 'Log Viewer',
      childBreadcrumb: 'Log Viewer',
    },
  },
  {
    path: 'addsites',
    component: AddSitesComponent,
    data: {
      parentBreadcrumb: 'Add Sites',
      childBreadcrumb: 'Add Sites',
    },
  },
  {
    path: 'editsites',
    component: EditSiteComponent,
    data: {
      parentBreadcrumb: 'Edit Sites',
      childBreadcrumb: 'Edit Sites',
    },
  },
  {
    path: 'bulkaction',
    component: BulkActionComponent,
    data: {
      parentBreadcrumb: 'Bulk Action',
      childBreadcrumb: 'Bulk Action',
    },
  },
  {
    path: 'group_action',
    data: {
      parentBreadcrumb: 'Group Action',
      childBreadcrumb: 'Group Action',
    },
    children: [
      {
        path: '',
        redirectTo: 'restore',
        pathMatch: 'full'
      },
      {
        path: 'restore',
        pathMatch: 'full',
        component: GrRestoreComponent,
        data: {
          parentBreadcrumb: 'Restore',
          childBreadcrumb: 'Restore',
        },
      },
      {
        path: 'cut',
        pathMatch: 'full',
        component: GrCutComponent,
        data: {
          parentBreadcrumb: 'Cut',
          childBreadcrumb: 'Cut',
        },
      },
    ]
  },
  {
    path: 'CreateBulkAction',
    component: BulkActionCreateComponent,
    data: {
      parentBreadcrumb: 'Create Bulk Action',
      childBreadcrumb: 'Create Bulk Action',
    },
  },
  {
    path: 'configuration',
    children: [
      {
        path: '',
        redirectTo: 'site_configuration',
        pathMatch: 'full'
      },
      {
        path: 'site_configuration',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Site Configuration',
          childBreadcrumb: 'Site Configuration',
        },
      },
      {
        path: 'hardware',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Hardware',
          childBreadcrumb: 'Hardware',
        },
      },
      {
        path: 'slab_configuration',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Slab Configuration',
          childBreadcrumb: 'Slab Configuration',
        },
      },
      {
        path: 'billing',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Billing',
          childBreadcrumb: 'Billing',
        },
      },
      {
        path: 'access',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Access',
          childBreadcrumb: 'Access',
        },
      },
      {
        path: 'administrator',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Administrator',
          childBreadcrumb: 'Administrator',
        },
      },
      {
        path: 'sodality',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Sodality',
          childBreadcrumb: 'Sodality',
        },
      },
      {
        path: 'master_action',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Master Action',
          childBreadcrumb: 'Master Action',
        },
      },
      {
        path: 'asset_entry',
        component: ConfigurationComponent,
        data: {
          parentBreadcrumb: 'Asset Entry',
          childBreadcrumb: 'Asset Entry',
        },
      },
    ]
  }

];

